<template>
  <div class="bgc-white flex-fill flex flex-column h-center">
    <div class="clr-blue" style="font-size: 80px; padding: 24px;">
      <i class="el-icon-warning-outline" />
    </div>
    <h4>很抱歉！系统正在维护，请耐心等待</h4>
    <div
      class="flex-fill flex flex-column v-bottom"
      style="width: 100%; padding: 20px; box-sizing: border-box;"
    >
      <van-button type="info" block @click="goBack">返回</van-button>
    </div>
  </div>
</template>
<script>
import { Button } from "vant";
export default {
  name: "maintaining",
  components: { [Button.name]: Button },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>
